import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  switchLabelStylesSAG,
  switchLabelStylesSHS,
} from './switch-label.styles';

@Directive({
  selector: 'label[sag-ui-switch-label]',
})
export class SwitchLabelDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const switchLabelStyles = componentStylesByTheme(
      this.theme,
      switchLabelStylesSAG,
      switchLabelStylesSHS
    );
    style(this.elementRef, switchLabelStyles());
  }
}
